<template>
   <div class="animated fadeIn">
      <!-- Main Wifi landing spot -->
      <b-card>
        <b-row>
         <b-col lg="12" md="12" sm="12" class="text-center">
          <h1 class="display-3">Data Insights</h1>
               WiFi has given us the freedom to work, play, and connect in any way we’d like. <br>
               Connection brings us all together and there is an underlying, fundamental reliance on this connectivity.<br> <p>How do these connections impact our visitors to the beautiful, historic Downtown Mall?</p>
               <img width="80" height="80" src="https://image.ibb.co/chYLEn/Picture1small.png" class="img-fluid">
               <br>
               <b>Are there insights that can be gained from visualizing this data?</b><br><br>
               <!-- Wifi Connectivity Image -->
         </b-col>
        </b-row>
      </b-card>

      <!-- Three box stats on home page -->
      <b-card>
        <b-row>
         <b-col lg="12" md="12" sm="12" class="text-center mt-4 mb-4">
            <h1 class="display-4">Access & Accessibility</h1>
            <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png" class="img-fluid">
            <h4 class="font-weight-bold"> Scope of the Data </h4>
            <br>
            <h5 class="font-weight-normal"> Data provided for this challenge spanned one year starting in January of 2017 and was anonymized. The data contained aggregated daily counts of WiFi users and sessions. In addition, there was 4-hour aggregated usage data in bytes collected from the city-provided, free WiFi on the Downtown Mall.</h5>
            <h5 class="font-weight-normal"> Additional data sources incorporated into the following analyses contain insights derived from local weather, events, and holidays.</h5>
            <br>
            <img src="https://preview.ibb.co/juNY4x/mallwifi.png" class="img-fluid"><br><br>
            <br>
            <img src="https://image.ibb.co/h23nQS/HOMEPAGE_ARROW_UP.png" class="img-fluid">
            
         </b-col>
        </b-row>
        <!-- <b-row class="text-center justify-content-center align-self-center">
          <b-card header="Scope of Data"  class="border-secondary mt-2">
             Data provided for this challenge spanned 1 year starting in Janurary of 2017 and was anonymized. The data contained aggregated daily usage data of WiFi users and sessions. In addition, there was 4-hour aggregated usage data in kilobytes collected from the city-provided, free WiFi on the Downtown Mall. 
          </b-card>
        </b-row> -->
        <b-row class="justify-content-center">
         <b-col md="4" sm="8" class="text-center">
          <!-- TODO: Add clarity on user count "Total Yearly Clients" -->
            <img src="https://preview.ibb.co/ntPmun/Yearly_Users.png" class="img-fluid-tiles">
         </b-col>
         <b-col md="4" sm="8" class="text-center">
          <!-- TODO: Try to define a session -->
            <img src="https://preview.ibb.co/bZZ877/yearlysessions.png" class="img-fluid-tiles">
         </b-col>
         <b-col md="4" sm="8" class="text-center">
            <img src="https://image.ibb.co/fOYxOp/yearlydatausage.png" class="img-fluid-tiles">
         </b-col>
        </b-row>

      <div slot="footer">
        <b-row class = "">
          <b-col lg="2" md="4" sm="3" class="offset-lg-1 text-center">
            <div class="text-muted">Monthly Average</div>
            <strong> <h5>3,478</h5> Users</strong>
            <b-progress class="progress-xs mt-2" :precision="1" variant="success" :value="100"></b-progress>
          </b-col>
          <b-col lg="2" md="4" sm="3" class="text-center">
            <div class="text-muted">Daily Average</div>
            <strong> <h5>118</h5> Users</strong>
            <b-progress class="progress-xs mt-2" :precision="1" variant="info" :value="100"></b-progress>
          </b-col>
          <b-col lg="2" md="4" sm="3" class="text-center">
            <div class="text-muted">Monthly Average</div>
            <strong> <h5>29,738</h5> Sessions</strong>
            <b-progress class="progress-xs mt-2" :precision="1" variant="warning" :value="100"></b-progress>
          </b-col>
          <b-col lg="2" md="6" sm="3" class="text-center">
            <div class="text-muted">Daily Average</div>
            <strong> <h5>1,019</h5> Sessions</strong>
            <b-progress class="progress-xs mt-2" :precision="1" variant="danger" :value="100"></b-progress>
          </b-col>
          <b-col lg="2" md="6" sm="3" class="text-center">
            <div class="text-muted">Yearly Data</div>
            <strong> <h5>1,071,854 (KB)</h5> Downloaded</strong>
            <b-progress class="progress-xs mt-2" :precision="1" :value="100"></b-progress>
          </b-col>
        </b-row>
      </div>


      </b-card>


      <!-- Clients per Day Line Plot Understanding Patterns -->
      <b-card>
       <b-row>
          <b-col lg="12" md="12" sm="12" class="text-center mt-4">
            <h1 class="display-4">Patterns & Trends</h1>
            <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png" class="img-fluid">
            <h4 class="font-weight-bold"> What do these trends tell us? </h4>
            <br>
            <h5 class="font-weight-normal"> A monthly average of 3,478 users was observed for the whole dataset. The peak time for WiFi visitors on the downtown mall is during the spring when the weather gets warmer (5,176 users in the month of April). Visitors and usage decrease as the year progresses, with an all-time low in November (1,393 users) and December* (1,262 users).</h5>
            <br>
            <h7 class="font-weight-light" color=#666> *December is not a complete month in this dataset.</h7>
         </b-col>
       </b-row>
       <br>
       <b-row>
          <b-col lg="12" md="12" sm="12">
              <h4 class="text-center justify-content-center align-self-center"> Count of Monthly Wifi Users on the Downtown Mall </h4>
             <line-example/>
          </b-col>
       </b-row>
      </b-card>
      <br>


      <!-- Weather and Wifi Card -->
      <b-card>
       <b-col lg="12" md="12" sm="12" class="text-center justify-content-center align-self-center ">
        <b-row class="text-center justify-content-center align-self-center mt-4">
          <h1 class="display-4">Impact of Weather</h1> <br><br>
         </b-row>
         <b-row class="text-center justify-content-center align-self-center mt-4">
            <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png" class="img-fluid text-center justify-content-center align-self-center mt-2">
         </b-row>
         <b-row class="text-center justify-content-center align-self-center mt-4">
            <h5 class="font-weight-normal text-center justify-content-center align-self-center mt-4"> 
              The Charlottesville Downtown Mall is an open air pedestrian mall. <br>
            As you might expect, the weather has a significant impact on WiFi usage on the Downtown Mall.</h5>
         </b-row>
        </b-col>

          <b-col lg="12" md="12" sm="12" class="text-center justify-content-center align-self-center ">
            <!-- TODO: KM Move middle box to the left, hot to cold -->
            <img src="static/img/weather_wifi.png" class="p-4 img-fluid"> <!-- ml-10 mr-10 -->
          </b-col>
          <!-- Weather Text Box to the right of the infographic -->
          <!-- <b-col md="4" class="text-center justify-content-center align-self-center">
           <b-card header="Key Takeaways from Weather" class="border-secondary mt-2">
            <h5> Impact of Rain on Clients Per Day:</h5>
              A 14% decrease in wifi users is observed on rainy days:<br>
              Clear days (125) vs Rainy Days (108)<br><br>
              <b> 13.6% Decrease in Wifi Users</b><br>
              Clear Days vs Cloudy Days both showed an equal average number of wifi users: 125<br><br>
            
            <h5> Impact of Wind on Clients Per Day:</h5>
              Wind >10mph vs wind < 10mph <br>
              92 vs 119 <br>
             </b-card>
           </b-col> -->
        <!--<b-col md="4" class="text-center">
            <h3>yo this is tesc</h3>
            <p>lorm ipsum olrem tgo l tehl g</p>
          </b-col> -->
       </b-row>
      </b-card>
  

      <!-- Top Mobile App Data Usage block -->
      <b-card>
        <!-- Header -->
        <b-row class="p-4">
         <b-col lg="12" md="12" sm="12" class="text-center mt-4">
          <h1 class="display-4">Mobile App Usage</h1>
          <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png" class="img-fluid">
         </b-col>
        </b-row>
        <!-- Infographic -->
        <b-row>
          <b-col lg="12" md="12" sm="12" class="text-center justify-content-center align-self-center mt-2
           mb-4">
            <img src="https://image.ibb.co/nO7ZHH/application_usage.png" class="p-4 img-fluid">
          </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col lg="4" md="6" sm="12" class="text-center">
             <h5 class=""> <i class="icon-social-facebook icons font-2xl"></i> Social Media App Usage (%) </h5>
             <pie-example :labels=labels_app_social :dataPoints=data_app_social :pieColors=pie_colors_app_social class="p-4 img-fluid" />
          </b-col>
          <!-- <b-col md="1">
          </b-col> -->
          <b-col lg="4" md="6" sm="12" class="text-center">
            <h5 class=""><i class="icon-social-youtube icons font-2xl"></i> Video App Usage (%)</h5>
            <pie-example :labels=labels_app_video :dataPoints=data_app_video :pieColors=pie_colors_app_video class="p-4 img-fluid" />
          </b-col>
        </b-row>
        <br>
        <br>
        <b-row class="justify-content-center">
          <b-col lg="4" md="6" sm="12" class="text-center">
            <h5 class=""><i class="icon-screen-smartphone icons font-2xl"></i> WiFi Users per Year by Device Type</h5>
              <pie-example :labels=labels_mobile :dataPoints=data_mobile :pieColors=pie_colors_mobile class="p-4 img-fluid" />
          </b-col>
          <!-- <b-col md="1">
          </b-col> -->
          <b-col lg="4" md="6" sm="12" class="text-center">
            <h5 class=""> <i class="icon-social-spotify icons font-2xl"></i> Music App Usage (%) </h5>
              <pie-example :labels=labels_app_music :dataPoints=data_app_music :pieColors=pie_colors_app_music class="p-4 img-fluid" />
          </b-col>
        </b-row>
<br>
<br>


        <b-row class="p-2">
          <b-col md="2" sm="0">
          </b-col>
           <b-col lg="8" md="8" sm="12" class="text-center justify-content-center align-self-center">
            <b-card header="<h4><b>What could we do with this data?</b></h4>" class="border-secondary mt-2">
              - Hosting events to draw more Apple or tech users to the downtown mall may bring in greater volume for tech business and increase the number of WiFi users.<br>
              - Device repair stores can utilize this data to better serve their customers and provide tailored services.<br>
              - Consider opening a technology related store, such as an Apple store, on the mall.<br>
              - Alternatively, bring in these specific vendors during key technology related events such as the TomTom Festival.<br><br>

                <b><u>Top Mobile Device Insights</u></b><br>
                - Apple dominates with the most users per device.<br> 
                - Samsung and LG additionally make up a large percentage of total device usage.<br>
                - Facebook is the most frequented social media application. <br>
                - Youtube has the highest number of for video streaming and iTunes is most popular for audio content. <br>
            </b-card>
          </b-col>
          <b-col md="2" sm="0">
          </b-col>
        </b-row>
      </b-card>
     <br>

      <!-- Events and Wifi -->
      <b-card>
        <b-row class="p-4 mb-4">
         <b-col lg="12" md="12" sm="12" class="text-center mt-4 mb-4">
            <h1 class="display-4">Events</h1>
            <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png" class="img-fluid">
            <br>
            <h5 class="font-weight-normal"> Many of the events on the downtown mall brought in greater numbers of WiFi users. Events with a focus on technology and music seem to resonate strongly within the Charlottesville community. Even for the least active month of the year, November, the Fridays After Five event on Nov 3rd brought in the highest number of daily users for that month. When reviewing the following infographic, keep in mind that, for comparison, the average daily WiFi user count on the Downtown Mall is 118 users. </h5>
         </b-col>
        </b-row>

      <b-row>
        <b-col lg="12" md="12" sm="12" class="text-center">
          <img src="https://image.ibb.co/i9G5Px/events_infographic.png" class="img-fluid">
        </b-col>
      </b-row>
      <br>
      <br>
      <b-row class="justify-content-center">
        <b-col lg="4" md="4" sm="12" class="text-center">
          <h6 class="">Average WiFi Users for Specific Event Categories</h6>
            <pie-example :labels=labels_events :dataPoints=data_events :pieColors=green_colors_events class="img-fluid"/>
        </b-col>
        <b-col lg="1" md="1" sm="0" class="text-center">
        </b-col>
        <b-col lg="4" md="4" sm="12" class="text-center">
          <h6 class="">Average WiFi Users by Day of Week</h6>
            <bar-example :labels=labels_dates :dataPoints=data_dates class="img-fluid"/>                   
        </b-col>
      </b-row>
    </b-card>

   

     <!-- Final Conclusions -->
     <b-card>
      <b-row>
       <b-col lg="12" md="12" sm="12" class="justify-content-center text-center">
        <div class="p-4">
        <h1 class="display-3">Conclusions</h1>
  
        <h5>We saw the largest increase in number of WiFi users when there were community driven events. We believe we can empower the businesses to attract community to engage with them to help promote other activities, for the benefit of both the business and community at large. Community events, such as Fridays After Five, consistently draw many people to the Downtown Mall. Events such as these can be expanded to bring the community and businesses together. Larger festivals such as the Tom Tom Festival even draw people from outside of Charlottesville.</h5> 
        <br>

        <img width="180" height="180" src="static/img/business_chain_people_logo.png" class="img-fluid"> <br>

        <b-card header="<h5><b>Five key insights that were revealed from the data:</b></h5>" class="border-secondary mt-2 img-fluid">
          <!-- <h5><u>Five key insights that were revealed from the data:</u></h5><br><br> -->

          1. <b>Know your visitors:</b> They tend to use Apple devices and businesses on the Downtown mall could leverage this information by creating more Apple-targeted products or offering related services.<br>
          2. <b>Engage with your visitors</b> on platforms they use. One way is to have business incentivize users to engage over social media (Facebook or Instagram for example).<br>
          3. <b>Impact of Weather:</b> Provide rainy day discounts because the data has shown that visitors are less likely to come out (post it on your Facebook, because they use Facebook).<br>
          4. <b>Day of the Week:</b> Knowing Sundays are a low traffic day, perhaps encourage restaurants to offer a Brunch on Sundays.<br>
          5. <b>Type of Event:</b> Continue to draw in visitors and wifi users through annual events. Music and technology related events tend to draw larger crowds.<br><br>

          When you better understand your users you are better able to cater to their needs. It's clear from the data that community events are what drives the highest usage and <b>connectivity</b> between businesses and WiFi users who have the potential to shop there.<br><br> 
         </b-card>

         <!-- TODO: Left Sidebar has awkward highlighting for home and story -->
        </div>
       </b-col>
      </b-row>
     </b-card>

     <b-card class="text-center justify-content-center align-self-center img-fluid">
      If you would like to download the "Events on the Downtown Mall" or "What can we learn from this data?" Infographic, please use the following links:<br>
      <b-row lg="12" md="12" sm="12" class="justify-content-center text-center" >
        <b-col lg="6" md="6" sm="12">
          <a href="https://image.ibb.co/i9G5Px/events_infographic.png" download="events_and_wifi_infographic.png" class="btn btn-primary m-4">Download "Events" Infographic</a>
        </b-col>
        <b-col lg="6" md="6" sm="12">
          <a href="https://image.ibb.co/jCXOBc/opening_infographic.png" download="events_and_wifi_infographic.png" class="btn btn-primary m-4">Download "Impact" Infographic</a>
        </b-col>
      </b-row>
    </b-card>

   </div>
</template>

       <!-- <div class="card-columns cols-2 ">
          <b-card header="Line Chart col-12">
             <div class="chart-wrapper">
                <line-example/>
             </div>
          </b-card>
          <b-card header="Bar Chart">
             <div class="chart-wrapper">
                <bar-example/>
             </div>
          </b-card>
          <b-card header="Doughnut Chart">
             <div class="chart-wrapper">
                <doughnut-example/>
             </div>
          </b-card>
          <b-card header="Radar Chart">
             <div class="chart-wrapper">
                <radar-example/>
             </div>
          </b-card>
          <b-card header="Pie Chart">
             <div class="chart-wrapper">
                <pie-example/>
             </div>
          </b-card>
          <b-card header="Polar Area Chart">
             <div class="chart-wrapper">
                <polar-area-example/>
             </div>
          </b-card>
       </div>
    </div>
 </template>

import BarExample from './charts/BarExample'
import LineExample from './charts/LineExample'
import DoughnutExample from './charts/DoughnutExample'
import RadarExample from './charts/RadarExample'
import PieExample from './charts/PieExample'
import PolarAreaExample from './charts/PolarAreaExample'
export default {
  name: 'dashboard',
  components: {
    BarExample,
    LineExample,
    DoughnutExample,
    RadarExample,
    PieExample,
    PolarAreaExample
  }
}
</script> -->

<script>
    import LineExample from './charts/LineExample'
    import PieExample from './charts/PieExample'
    import BarExample from './charts/BarExample'
    import { Carousel, Slide } from 'vue-carousel'

    export default {
      name: 'story',
      data () {
        return {
          labels_app: ['label'],
          data_app: [12],
          // Title: "Social Media App Usage"
          labels_app_social: ['Facebook', 'Tumblr', 'Instagram', 'Snapchat'],
          data_app_social: [42.8, 5.6, 30.2, 21.4],
          pie_colors_app_social: ['#3b5998', '#35465c', '#c13584', '#fffc00'],
          // Title: "Music App Usage"
          labels_app_music: ['iTunes', 'Spotify', 'Misc. audio', 'Pandora'],
          data_app_music: [64.3, 20.1, 8.4, 7.2],
          pie_colors_app_music: ['#6762a6', '#1db954', '#28353d', '#005483'], // '#C36891',
          // Title: Video App Usage
          // TODO: social media icons
          labels_app_video: ['YouTube', 'Misc. video', 'Netflix'],
          data_app_video: [68.6, 13.5, 17.8],
          pie_colors_app_video: ['#ff0000', '#564d4d', '#831010'], // '#db0000'
          // Top Device Categories
          labels_mobile: ['Apple', 'Samsung', 'Murata Mfg', 'Intel', 'Kyocera', 'Motorola', 'HTC', 'Huawei Tech'],
          data_mobile: [6544, 742, 420, 531, 140, 153, 360, 119],
          pie_colors_mobile: ['#5270ff', '#E46651', '#00D8FF', '#41B883', '#00BCD4', '#03A9F4', '#009688', '#673AB7', '#3F51B5', '#2196F3', '#F44336', '#E91E63', '#9C27B0', '#4CAF50', '#FFEB3B', '#CDDC39', '#FFC107', '#FF9800', '#FF5722', '#795548', '#607D8B', '#9E9E9E'],
          // Top Events
          labels_events: ['Festivals', 'Fridays After Five', 'General', 'Holiday', 'Kids Event', 'Movie', 'Speaker/Performance', 'Theme Week'],
          data_events: [171, 212, 111, 102, 90, 101, 136, 95],
          green_colors_events: ['#C2E79A', '#92C060', '#699A33', '#457313', '#284D00', '#C2E79A', '#92C060', '#699A33'],
          // Clients by Days of the Week
          labels_dates: ['Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun'],
          data_dates: [96, 112, 121, 119, 154, 134, 94],
          default_pie_colors: ['#41B883', '#E46651', '#00D8FF', '#DD1B16', '#00BCD4', '#03A9F4', '#009688', '#673AB7', '#3F51B5', '#2196F3', '#F44336', '#E91E63', '#9C27B0', '#4CAF50', '#FFEB3B', '#CDDC39', '#FFC107', '#FF9800', '#FF5722', '#795548', '#607D8B', '#9E9E9E']
        }
      },
      components: {
        LineExample,
        PieExample,
        BarExample,
        Carousel,
        Slide
      }
}
</script>


// WEBPACK FOOTER //
// src/views/Story.vue